import { AxiosResponse } from "axios";
import {
    findTokens,
    LANG_ENG,
    LANG_URD,
    TokenType,
} from "../../../helpers/translate";
import { Translate } from "../../../models";
import { cache } from "./index";

export function enSentences(text: string) {
    const tokens: Array<{
        type: TokenType;
        value: string;
    }> = [];
    findTokens(text, tokens);

    const list = [];
    let char;
    let sentence = "";

    const CHAR_FULLSTOP = ".";
    const CHAR_SPACE = " ";
    const CHAR_NEWLINE = "\n";
    const STOP_CHARS = [CHAR_SPACE, CHAR_NEWLINE];

    for (let i = 0, len = text.length; i < len; i += 1) {
        char = text[i];
        if (char === CHAR_NEWLINE) {
            list.push(sentence);
            list.push(char);
            sentence = "";
            continue;
        } else if (char === CHAR_FULLSTOP) {
            if (i === len || (i < len && STOP_CHARS.includes(text[i + 1]))) {
                sentence += char;
                list.push(sentence);
                sentence = "";
                continue;
            }
        }

        sentence += char;
    }

    if (sentence.length > 0) {
        list.push(sentence);
    }

    return list;
}

export async function en2ur(list: string[]) {
    try {
        const reChars = RegExp(/[a-zA-Z]+/);
        const src = [];
        const dst = [];

        let src_text;
        for (let i = 0, len = list.length; i < len; i += 1) {
            src_text = list[i];
            if (!src_text.match(reChars)) {
                src.push(src_text);
                dst.push(src_text);
                continue;
            }

            if (cache[LANG_ENG][LANG_URD][src_text]) {
                src.push(src_text);
                dst.push(cache[LANG_ENG][LANG_URD][src_text]);
                continue;
            }

            const {
                data: { translation },
            }: AxiosResponse<{
                translation: string;
            }> = await Translate.create(
                { src_text },
                {
                    src_lang: LANG_ENG,
                    dst_lang: LANG_URD,
                }
            );

            cache[LANG_ENG][LANG_URD][src_text] = translation;

            src.push(src_text);
            dst.push(translation);
        }

        return {
            src,
            dst,
        };
    } catch (e) {
        console.warn("engToUrd translation failed");
        console.warn(e);
        return {
            src: [],
            dst: [],
        };
    }
}
